import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';
import { Theme } from './types';

const {
    default: styled,
    css,
    createGlobalStyle,
    ThemeProvider,
    ThemeConsumer,
    keyframes,
    useTheme,
} = (styledComponents as any) as ThemedStyledComponentsModule<Theme>;

export { css, createGlobalStyle, keyframes, ThemeProvider, ThemeConsumer, useTheme };
export default styled;